/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// Russian strings for the Servers tab. The app translates rendered text nodes
// by exact match (utils/language.tsx), so these keys are the literal English UI
// text. Spread first into `ruPhrases` so existing translations win.
export const serversRuPhrases: Record<string, string> = {
  "Add server": "Добавить сервер",
  "No servers yet": "Серверов пока нет",
  "Install the agent on a machine, then add it here to see live CPU, memory, disks, network and health.":
    "Установите агент на машину и добавьте её сюда, чтобы видеть CPU, память, диски, сеть и состояние в реальном времени.",
  "loading…": "загрузка…",
  "collecting metrics…": "сбор метрик…",
  Live: "Онлайн",
  "Traffic history": "История трафика",
  Hardware: "Железо",
  Edit: "Изменить",
  Remove: "Удалить",
  Reboot: "Перезагрузить",
  "Shut down": "Выключить",
  "Power on": "Включить",
  Cancel: "Отмена",
  online: "в сети",
  offline: "не в сети",
  disabled: "отключён",
  checking: "проверка",
  "no data": "нет данных",
  "no live data": "нет данных",
  "connecting…": "подключение…",
  "monitoring disabled": "мониторинг отключён",
  "no data — agent unreachable": "нет данных — агент недоступен",
  "Monitoring is disabled for this server. Enable it via Edit.": "Мониторинг этого сервера отключён. Включите его через «Изменить».",
  "All checks green - no problems detected.": "Все проверки в порядке — проблем не найдено.",
  "Rebooting - waiting for the server to come back.": "Перезагрузка — ждём возвращения сервера.",
  "Shutting down...": "Выключение…",
  "Magic packet sent - waiting for the server to boot.": "Magic-пакет отправлен — ждём загрузки сервера.",
  "Reboot server": "Перезагрузка сервера",
  "Shut down server": "Выключение сервера",
  "Power on server": "Включение сервера",
  "The host and everything running on it (VMs, containers, storage) restarts. Services are unavailable for a few minutes.":
    "Хост и всё, что на нём работает (ВМ, контейнеры, хранилище), перезапустится. Сервисы будут недоступны несколько минут.",
  "The host powers off completely. It can only be started again with Wake-on-LAN from the router or the power button.":
    "Хост полностью выключится. Включить его снова можно только через Wake-on-LAN с роутера или кнопкой питания.",
  "Reboot now": "Перезагрузить сейчас",
  "Shut down now": "Выключить сейчас",
  "Send magic packet": "Отправить magic-пакет",
  "Working...": "Выполняется…",
  "to confirm": "для подтверждения",
  CPU: "CPU",
  Memory: "Память",
  Network: "Сеть",
  "Pressure (PSI)": "Нагрузка (PSI)",
  "time tasks were stalled": "доля времени простоя задач",
  "CPU waiting": "Ожидание CPU",
  "Memory waiting": "Ожидание памяти",
  "Memory stalled": "Остановка из-за памяти",
  "I/O waiting": "Ожидание диска",
  "I/O stalled": "Остановка из-за диска",
  "Load average": "Средняя загрузка",
  Threads: "Потоки",
  Swap: "Подкачка",
  "ZFS ARC": "ZFS ARC",
  "reclaimable cache": "освобождаемый кэш",
  Cached: "В кэше",
  Buffers: "Буферы",
  Free: "Свободно",
  "live, from interface counters": "онлайн, по счётчикам интерфейсов",
  Interface: "Интерфейс",
  Link: "Линк",
  Down: "Приём",
  Up: "Отдача",
  "Total in": "Принято",
  "Total out": "Отдано",
  "Err / drop": "Ошибки / потери",
  Filesystems: "Файловые системы",
  "Disk I/O": "Дисковый ввод-вывод",
  "per device": "по устройствам",
  Device: "Устройство",
  Read: "Чтение",
  Write: "Запись",
  Busy: "Занятость",
  "Total read": "Прочитано",
  "Total written": "Записано",
  "Drive health (SMART)": "Состояние дисков (SMART)",
  Drive: "Диск",
  Health: "Состояние",
  Temp: "Темп.",
  "Power-on": "Наработка",
  Cycles: "Включений",
  Realloc: "Переназн.",
  Pending: "Нестаб.",
  CRC: "CRC",
  "SSD wear": "Износ SSD",
  Size: "Объём",
  "ZFS pools": "Пулы ZFS",
  device: "устройство",
  state: "статус",
  Temperatures: "Температуры",
  UPS: "ИБП",
  Battery: "Батарея",
  Load: "Нагрузка",
  Input: "Вход",
  Output: "Выход",
  "Battery voltage": "Напряжение батареи",
  "Proxmox guests": "Гости Proxmox",
  Guest: "Гость",
  State: "Статус",
  Disk: "Диск",
  "Net in / out": "Сеть вх. / исх.",
  Uptime: "Аптайм",
  "Docker containers": "Контейнеры Docker",
  Container: "Контейнер",
  Image: "Образ",
  Status: "Статус",
  Services: "Службы",
  systemd: "systemd",
  "all units healthy": "все службы в порядке",
  "Top processes": "Топ процессов",
  Process: "Процесс",
  User: "Пользователь",
  PID: "PID",
};
